var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlighment20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE9\x80\x9A\xE7\x94\xA8\xE5\x9B\xBE\xE6\xA0\x87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1271",
    y: 2.5,
    width: 20,
    height: 2.5,
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1273",
    x: 2.5,
    width: 7.5,
    height: 2.5,
    transform: "rotate(90 2.5 0)",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1274",
    x: 20,
    width: 7.5,
    height: 2.5,
    transform: "rotate(90 20 0)",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1272",
    x: 3.125,
    y: 8.125,
    width: 13.75,
    height: 3.75,
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 23",
    d: "M16.875 16.25C16.875 16.9213 16.3146 17.6972 15.0238 18.3426C13.7704 18.9693 11.9951 19.375 10 19.375C8.00492 19.375 6.22962 18.9693 4.97621 18.3426C3.68542 17.6972 3.125 16.9213 3.125 16.25C3.125 15.5787 3.68542 14.8028 4.97621 14.1574C6.22962 13.5307 8.00492 13.125 10 13.125C11.9951 13.125 13.7704 13.5307 15.0238 14.1574C16.3146 14.8028 16.875 15.5787 16.875 16.25Z",
    stroke: "#222627",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlighment20);
export default __webpack_public_path__ + "static/media/alighment_20.4dc8eebfda798eac8b8965cd31618675.svg";
export { ForwardRef as ReactComponent };